import ReactPixel from './facebookPixel';
import {
  alphabet,
  animateScroll,
  defaultPageSize,
  formatNum,
  generateProductRows,
  generateRowImages,
  genRandomStr,
  getCookie,
  getCookieValue,
  getCreditCardType,
  getNextSkipAmount,
  getPrevSkipAmount,
  invalidCcNumCheck,
  isNumber,
  roundDownToMultipleOf60,
  separateProductDataIntoRows,
  setCookieValue,
  onSaleParam,
  newInParam,
  sortOptionInsertTimePriceAsc,
  sortOptionInsertTimePriceDesc,
  sortOptionPVInsertTime,
  sortOptions,
  tag
} from './helpers';
import { locationIncludes } from './hrefLocation';
import {
  changeUrlFiltersVisibility,
  generateFilterUrl,
  generateHistoryUrl,
  PAGE_BRAND_DETAIL,
  PAGE_SEARCH,
  SEARCH_ENDPOINT,
  setSearchStore
} from './routeHelpers';
import {
  categoriesWithSizes,
  getDefaultSizeGuideTabId,
  getDefaultSizeGuideTabIdFromPath,
  menCategoryId,
  searchCategoryInTree,
  searchTreeForCategoryWithSizes,
  splitSizes,
  womenCategoryId
} from './search_helpers';

import { businessEmail, customerCareEmail, hrEmail, mailTo, marketingEmail, pressEmail } from './emailAddresses';

import { easeInOutQuint, easeInOutSine, easeOutSine, scrollElementToCenter, scrollToY } from './animatedScrolling';

import { genImageAlt } from './seoHelper';

import {
  getProductsViewedData,
  getProductTrackingData,
  initTracking,
  normalizeProductSelected,
  track
} from './tracking';

import { getDefaultOptions, transformImagesToPhotoswipe, updatePhotoswipeImages } from './photoswipe';

import { capitalizeFirstLetters } from './stringFormatters';

export {
  alphabet,
  animateScroll,
  changeUrlFiltersVisibility,
  capitalizeFirstLetters,
  defaultPageSize,
  initTracking,
  invalidCcNumCheck,
  normalizeProductSelected,
  formatNum,
  generateProductRows,
  generateRowImages,
  genRandomStr,
  getCookie,
  getCookieValue,
  getCreditCardType,
  getDefaultOptions,
  getNextSkipAmount,
  getPrevSkipAmount,
  getProductsViewedData,
  getProductTrackingData,
  isNumber,
  roundDownToMultipleOf60,
  separateProductDataIntoRows,
  setCookieValue,
  onSaleParam,
  newInParam,
  sortOptions,
  sortOptionPVInsertTime,
  sortOptionInsertTimePriceDesc,
  sortOptionInsertTimePriceAsc,
  splitSizes,
  tag,
  track,
  transformImagesToPhotoswipe,
  updatePhotoswipeImages,
  locationIncludes,
  ReactPixel,
  setSearchStore,
  generateFilterUrl,
  generateHistoryUrl,
  categoriesWithSizes,
  getDefaultSizeGuideTabId,
  getDefaultSizeGuideTabIdFromPath,
  searchTreeForCategoryWithSizes,
  searchCategoryInTree,
  menCategoryId,
  womenCategoryId,
  SEARCH_ENDPOINT,
  PAGE_BRAND_DETAIL,
  PAGE_SEARCH,
  customerCareEmail,
  pressEmail,
  businessEmail,
  hrEmail,
  marketingEmail,
  mailTo,
  easeOutSine,
  easeInOutSine,
  easeInOutQuint,
  scrollElementToCenter,
  scrollToY,
  genImageAlt
};
